import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { Loader2, AlertCircle, MailX } from "lucide-react";
import { SimpleCard } from "./ResumeOrder";
import { API, apiError } from "@/lib/api";

export default function Unsubscribe() {
  const { token } = useParams();
  const [state, setState] = useState({ kind: "confirm" });

  useEffect(() => {
    document.title = "Désinscription des rappels | ClimNova";
  }, []);

  const confirm = async () => {
    setState({ kind: "loading" });
    try {
      await axios.post(`${API}/reminders/unsubscribe/${token}`);
      setState({ kind: "done" });
    } catch (e) {
      setState({ kind: "error", msg: apiError(e) });
    }
  };

  return (
    <SimpleCard testid="unsubscribe-page">
      {(state.kind === "confirm" || state.kind === "loading") && (
        <>
          <MailX className="w-14 h-14 text-sky-600" />
          <h1 data-testid="unsubscribe-confirm-title" className="font-display text-3xl font-extrabold text-slate-900">Ne plus recevoir les rappels ?</h1>
          <p className="text-slate-600">Vous ne recevrez plus de rappels concernant vos commandes non finalisées. Les e-mails liés à une commande payée (confirmation, livraison) restent envoyés.</p>
          <button type="button" onClick={confirm} disabled={state.kind === "loading"} data-testid="unsubscribe-confirm-button" className="btn-heat mt-2 disabled:opacity-70">
            {state.kind === "loading" ? <Loader2 className="w-5 h-5 animate-spin" /> : "Confirmer la désinscription"}
          </button>
          <Link to="/" className="text-sm text-sky-700 underline underline-offset-4">Retour au site</Link>
        </>
      )}
      {state.kind === "done" && (
        <>
          <MailX className="w-14 h-14 text-sky-600" />
          <h1 data-testid="unsubscribe-success" className="font-display text-3xl font-extrabold text-slate-900">C'est noté</h1>
          <p className="text-slate-600">Vous ne recevrez plus de rappels concernant vos commandes non finalisées.</p>
          <Link to="/" className="btn-heat mt-2">Retour au site</Link>
        </>
      )}
      {state.kind === "error" && (
        <>
          <AlertCircle className="w-14 h-14 text-orange-600" />
          <h1 data-testid="unsubscribe-error" className="font-display text-3xl font-extrabold text-slate-900">Lien invalide</h1>
          <p className="text-slate-600">{state.msg}</p>
          <Link to="/" className="btn-heat mt-2">Retour au site</Link>
        </>
      )}
    </SimpleCard>
  );
}
